import { render, staticRenderFns } from "./PeriodsSelectionSection.vue?vue&type=template&id=fc58b8c8"
import script from "./PeriodsSelectionSection.vue?vue&type=script&lang=js"
export * from "./PeriodsSelectionSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports